import React from 'react'

import {
  Flex,
  LoadingSpinner,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { Button } from 'src/design_system/components/Button/Button'
import { useState } from 'src/hooks'
import { SubscriptionSelection } from './SubscriptionSelection'
import { PlanFragment } from 'src/legacy_graphql'
import { useProductVariants } from 'src/react_query/queries/hooks'
import { PlanIdType } from '../pricingTile/PlanTiles'

type StepPackageProps = {
  premiumSubVariantIds: string[]
  isMobile: boolean
  onSkip: () => void
  onContinue: (plan: PlanFragment) => void
}

export const StepPackage: React.FC<StepPackageProps> = ({
  isMobile,
  premiumSubVariantIds,
  onSkip,
  onContinue,
}) => {
  const [selectedPlan, setSelectedPlan] = useState<PlanFragment | undefined>()

  const handlePlanSelection = (plan: PlanFragment) => {
    setSelectedPlan(plan)
  }

  const { data: premiumSubs } = useProductVariants({
    first: 100,
    ids: premiumSubVariantIds,
  })

  const pSubsIds = premiumSubs
    ? premiumSubs.pages[0]?.edges.map(
        pSub =>
          ({
            id: pSub.node.metadata.find(k => k.key === 'plan_id')?.value ?? '',
          } as PlanIdType),
      )
    : []

  return (
    <>
      <Flex
        style={{
          padding: '1rem 2rem 2rem 2rem',
          paddingBottom: isMobile ? '80px' : '2rem',
        }}
      >
        <Flex flexDirection="column" width="100%">
          <Text
            type="caption"
            weight="bold"
            content="Subscription Plans:"
            style={{ color: '#D1D5DB' }}
          />
          <Spacer space="x1" />
          {pSubsIds && pSubsIds.length > 0 ? (
            <SubscriptionSelection
              planIds={pSubsIds}
              onSelectPlan={handlePlanSelection}
            />
          ) : (
            <Flex
              width="100%"
              alignItems="center"
              justifyContent="center"
              inset="x6"
            >
              <LoadingSpinner size="xLarge" />
            </Flex>
          )}
        </Flex>
      </Flex>
      <Flex
        justifyContent="flex-end"
        alignItems="center"
        inset={{
          horizontal: 'x4',
          bottom: 'x2',
          top: isMobile ? 'x2' : undefined,
        }}
        style={{
          position: isMobile ? 'fixed' : undefined,
          bottom: isMobile ? 0 : undefined,
          right: isMobile ? 20 : undefined,
          backgroundColor: isMobile ? '#F8F5F6' : undefined,
        }}
      >
        <div onClick={onSkip} style={{ cursor: 'pointer' }}>
          <Text
            type="body"
            weight="semiBold"
            style={{ textDecoration: 'underline' }}
            content="Skip this step"
          />
        </div>
        <Spacer space="x2" orientation="horizontal" />
        <Button
          title="Yes, I confirm"
          backgroundColor="#404040"
          textColor="#FFF"
          textSize="14px"
          padding="0.75rem 2rem"
          onClick={() => {
            if (selectedPlan) onContinue(selectedPlan)
          }}
          isDisabled={!selectedPlan}
        />
      </Flex>
    </>
  )
}
